import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IBatchcredit } from 'app/core/interfaces/posting.interface';
import { PostingService } from 'app/core/services/posting.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { creditTypesEnum } from '../posting.component';

@Component({
  selector: 'app-credit-edit',
  templateUrl: './credit-edit.component.html',
  styleUrls: ['./credit-edit.component.scss']
})
export class CreditEditComponent implements OnInit, OnDestroy {

  subscription: Subscription[] = [];
  formCharges: FormGroup;
  dataGrid: IBatchcredit;
  listCredit = [];
  constructor(private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private fb: FormBuilder,
    private t2LoadingService: T2LoadingService,
  ) {
    this.initFormCharges();
  }

  ngOnInit() {
    this.subcriptions();
  }

  initFormCharges(): void {
    this.formCharges = this.fb.group({
      dateofservice: [null, [Validators.required]],
      payordescription: [null],
      payorid: [null, [Validators.required]],
      riderfullname: [null],
      totalamounttrip: [null],
      tripid: [null, [Validators.required]],
      claim: [null],
      consecutive: [null],
      batchinfoid: [null, [Validators.required]],
      batchcreditid: [null],
      cptmod: [{ value: null, disabled: true }],
      chargedescription: [{ value: null, disabled: true }],
      billed: [{ value: 0, disabled: true }],
      allowance: [{ value: 0, disabled: true }],
      payment: [{ value: 0, disabled: true }],
      balance: [{ value: 0, disabled: true }],
      amount: [null, Validators.required],
      creditid: [null, Validators.required],
      denialcode: [{ value: null, disabled: true }],
      contractualamount: [null, [Validators.required]],
      contractualcreditid: [null, Validators.required],
      newbalance: [{ value: null, disabled: true }],
      tripchargeid: [null],
    });
  }

  onSave(): void {
    if (this.formCharges.valid) {
      this.t2LoadingService.show();
      const formCharge = this.formCharges.getRawValue();
      const data = {
        payorid: formCharge.payorid,
        totalamounttrip: formCharge.totalamounttrip,
        tripid: formCharge.tripid,
        consecutive: formCharge.consecutive,
        batchinfoid: formCharge.batchinfoid,
        batchcreditid: formCharge.batchcreditid,
        amount: formCharge.amount ? formCharge.amount : formCharge.contractualamount,
        creditid: formCharge.creditid ? formCharge.creditid : formCharge.contractualcreditid,
        denialcode: formCharge.denialcode,
        newbalance: formCharge.newbalance,
        tripchargeid: formCharge.tripchargeid,
        icn: formCharge.claim,
      };
      this.postingService.putBatchCredit(data)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe((resp) => {
          if (resp) {
            this.sweetAlertHelper.createCustomAlert({ title: 'Success', text: resp.message, type: 'success' })
              .then(() => {
                this.postingService.modeEditCreditSubject.next({ isEditMode: false });
                this.postingService.setBatchInfoId(formCharge.batchinfoid);
              });
          }
        }, (err) => this.sweetAlertHelper.captureException(err));
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: '¡Action not allowed!',
        type: 'error'
      }).then(() => {
        this.onCancelCredit();
      });
    }
  }

  getTypeCreditList(type: number): void {
    this.subscription.push(
      this.postingService.getCreditTypeList(type).subscribe((resp) => {
        this.listCredit = resp;
      },
        (error) => this.sweetAlertHelper.captureException(error)
      )
    );
  }

  subcriptions(): void {
    this.subscription.push(
      this.postingService.creditEditSubject$.subscribe((resp: any) => {
        this.setValueForm(resp);
      })
    );

    this.subscription.push(
      this.postingService.batchInfoId.subscribe((batchInfoId: number) => {
        if (batchInfoId) {
          this.formCharges.get('batchinfoid').setValue(batchInfoId);
        }
      })
    );

    this.subscription.push(
      this.postingService.dataGrid$.subscribe((data) => {
        if (data) {
          this.dataGrid = data;
          this.formCharges.patchValue({
            batchcreditid: data.batchcreditid,
            claim: data.icn,
          });
        }
      })
    );

    this.subscription.push(
      this.formCharges.get('creditid').valueChanges.subscribe((id) => {
        this.formCharges.get('denialcode').setValue(null);
        this.formCharges.controls['denialcode'].disable();
        if (id && id === EnumTypeCredit.denial) {
          this.formCharges.controls['denialcode'].enable();
        };
      })

    );
  }

  setValueForm(resp): void {
    if (resp) {
      this.formCharges.patchValue({
        dateofservice: resp.dateofservice,
        payordescription: resp.payordescription,
        payorid: resp.payorid,
        riderfullname: resp.riderfullname,
        totalamounttrip: resp.totalamounttrip,
        tripid: resp.tripid,
        consecutive: resp.consecutive,
      });
      if (resp.chargeslist && this.dataGrid.tripchargeid) {
        resp.chargeslist.filter((item) => {
          if (item.tripchargeid === this.dataGrid.tripchargeid) {
            this.formCharges.patchValue({
              cptmod: item.cptmod,
              chargedescription: item.chargedescription,
              billed: item.billed,
              allowance: item.allowance,
              payment: item.payment,
              balance: item.balance,
              tripchargeid: item.tripchargeid,
              newbalance: item.balance
            });
            this.validateTyCredit();
          }
        });
      } else {
        this.validateTyCredit();
      }
    }

  }

  validateTyCredit(): void {
    if (this.dataGrid.credittypegroupid) {
      const creditTypeGroup = {
        '1': () => this.setPropertyForm('contractualamount', 'contractualcreditid', creditTypesEnum.payment),
        '3': () => this.setPropertyForm('amount', 'creditid', creditTypesEnum.contractual),
        '4': () => this.setPropertyForm('contractualamount', 'contractualcreditid', creditTypesEnum.denials),
        '6': () => this.setPropertyForm('contractualamount', 'contractualcreditid', creditTypesEnum.denials)
      };
      return creditTypeGroup[creditTypeGroup[this.dataGrid.credittypegroupid]()];
    }
  }

  setPropertyForm(propertyAmount: string, propertyCredit: string, creditType: number) {
    const amountDenial = this.dataGrid.amount ? this.dataGrid.amount : 0;
    this.getCreditList(amountDenial, creditType);
    const amount = creditTypesEnum.contractual !== creditType ? 'amount' : 'contractualamount';
    const credit = creditTypesEnum.contractual !== creditType ? 'creditid' : 'contractualcreditid';
    this.formCharges.get(amount).setValue(amountDenial);
    this.formCharges.get(credit).setValue(this.dataGrid.creditid);
    this.setValidatorsControl(propertyAmount, null);
    this.setValidatorsControl(propertyCredit, null);
    if (creditType === creditTypesEnum.denials) {
      this.formCharges.get('denialcode').setValue(this.dataGrid.denialcode);
    }
  }

  onCancelCredit(): void {
    this.postingService.modeEditCreditSubject.next({ isEditMode: false });
  }

  onChangeAmount(typeCredit: number, property: string): void {
    const { amount, contractualamount } = this.formCharges.getRawValue();
    const propertyChange = {
      'amount': () => {
        this.formCharges.get('creditid').setValue(null);
        this.getCreditList(amount, typeCredit);
      },
      'contractualamount': () => {
        this.formCharges.get('contractualcreditid').setValue(null);
        this.getCreditList(contractualamount, typeCredit);
      }
    };
    this.getNewBalance(this.formCharges.getRawValue());
    return propertyChange[propertyChange[property]()];
  }

  getCreditList(amount: number, typeCredit: number): void {
    if (typeCredit === creditTypesEnum.contractual) {
      this.getTypeCreditList(creditTypesEnum.contractual);
      return;
    }
    const select: any = Number(amount) === 0 ? 'Zero' : Number(amount) > 0 ? 'Mayor' : 'Minor';
    const valueAmount = {
      'Zero': () => this.getTypeCreditList(creditTypesEnum.denials),
      'Mayor': () => this.getTypeCreditList(creditTypesEnum.payment),
      'Minor': () => this.getTypeCreditList(creditTypesEnum.refund)
    };
    return valueAmount[valueAmount[select]()];
  }

  setValidatorsControl(property: string, validators): void {
    this.formCharges.controls[property].setValidators(validators);
    this.formCharges.controls[property].updateValueAndValidity();
    this.formCharges.controls[property].disable();
  }

  getNewBalance(formCharge): void {
    const { balance, amount, contractualamount } = formCharge;
    const newAmount = (this.dataGrid.amount) + (Number(balance));
    const amountOperation = (Number(newAmount) - (amount ? amount : contractualamount));
    this.formCharges.get('newbalance').setValue(amountOperation);
  }

  get currentBalance(): string {
    const totalAmountBalance = this.formCharges.get('totalamounttrip').value;
    return `$${Number.parseFloat(totalAmountBalance).toFixed(2)}`;
  }

  get riderFullName(): string {
    return this.formCharges.get('riderfullname').value;
  }

  get dateOfservice(): string {
    return this.formCharges.get('dateofservice').value;
  }

  get consecutiveNumber(): string {
    return this.formCharges.get('consecutive').value;
  }

  get payorDescription(): string {
    return this.formCharges.get('payordescription').value;
  }

  get validateForm(): boolean {
    return this.formCharges.invalid;
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subs) => subs.unsubscribe());
  }
}

const enum EnumTypeCredit {
  denial = 19
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/posting/credit-edit/credit-edit.component.ts